import RequireAuth from '@converge/ui/domain/auth/require-auth';
import { BrokerageTabs } from '@converge/ui';

export const BrokerageDetailPage = () => {
  return (
    <RequireAuth>
      <BrokerageTabs />
    </RequireAuth>
  );
};

export default BrokerageDetailPage;
